/**
 * crypto.randomUUID() is secure-context-only in browsers: it exists on https
 * and on localhost (a secure context, incl. http://localhost:3000), but NOT on
 * other plain-HTTP origins. Server-side (Node 19+) it always exists. This
 * wrapper keeps a getRandomValues fallback for any insecure context (e.g.
 * serving dev over HTTP on a non-localhost host/LAN IP).
 */
export function randomUUID(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();

  // RFC 4122 v4 from getRandomValues, which IS available in insecure contexts.
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** A UUID of any version, in either case (fixture and imported ids need not be RFC-versioned). */
export const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True when `value` is UUID-shaped: a sale id from a webhook's metadata is not trusted otherwise. */
export function isUuid(value: string): boolean {
  return UUID_RE.test(value);
}
